"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_dom_1 = __importDefault(require("react-dom"));
const react_1 = __importDefault(require("react"));
const PeopleStore_1 = require("./model/PeopleStore");
const Holds_1 = __importDefault(require("./model/Holds"));
const mobx_react_1 = require("mobx-react");
const serviceWorker = __importStar(require("./serviceWorker"));
const CovidNav_1 = require("./model/CovidNav");
const Roles_1 = __importDefault(require("./model/Roles"));
const aws_react_1 = require("@mit/aws-react");
const Initializer_1 = require("./hooks/Initializer");
require("./scss/main.scss");
const react_router_dom_1 = require("react-router-dom");
const Logout_1 = __importDefault(require("./components/Logout"));
// @ts-ignore
const app_config_global_1 = __importDefault(require("./app-config-global"));
// @ts-ignore
const App = react_1.default.lazy(() => __awaiter(void 0, void 0, void 0, function* () { return yield Promise.resolve().then(() => __importStar(require('./App'))).then(module => ({ default: module.default })); }));
const WrappedOKTAApp = () => {
    const { initializeApp } = (0, Initializer_1.useAppInitializer)();
    // var combinedConfig = {...appConfig, ...appPathConfig};
    return (0, jsx_runtime_1.jsxs)(react_1.default.StrictMode, { children: [(0, jsx_runtime_1.jsx)("link", { rel: "stylesheet", href: "https://pro.fontawesome.com/releases/v5.15.4/css/all.css", integrity: "sha384-rqn26AG5Pj86AF4SO72RK5fyefcQ/x32DNQfChxWvbXIyXFePlEktwD18fEz+kQU", crossOrigin: "anonymous" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: '/logout', component: Logout_1.default }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, Object.assign({ path: '*' }, { children: (0, jsx_runtime_1.jsx)(aws_react_1.Initialization, { App: App, appInitializer: initializeApp, appConfigData: app_config_global_1.default, loaderProps: {
                                    backgroundColor: '#07393c',
                                    contactEmail: 'help@mit.edu',
                                    name: 'Covid Medical',
                                    isLoading: true,
                                    type: 'Default',
                                    message: 'You are unauthorized to use this application.'
                                } }) }))] }) })] });
};
react_dom_1.default.render((0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ covidNav: CovidNav_1.covidNav, holds: Holds_1.default, roles: Roles_1.default, peopleStore: PeopleStore_1.peopleStore }, { children: (0, jsx_runtime_1.jsx)(WrappedOKTAApp, {}) })), document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
